import React from 'react';
import { livePricingValue } from '../utils/pricingWorkspace';

const money=value=>value==null?'—':`₹${Number(value).toLocaleString('en-IN',{maximumFractionDigits:2})}`;
export default function PricingBatchDetails({row,changes={}}){
  const batches=row.batches||[];
  if(!batches.length)return <span className="text-xs text-gray-500">Batch details unavailable</span>;
  return <details className="mt-2 text-xs"><summary className="cursor-pointer font-semibold">Batch details ({batches.length})</summary>
    <p className="my-2">Warehouse stock batches. Calculated prices below use each batch’s cost and MRP with this row’s selling margin. The outlet uses one published pack price.</p>
    {batches.map(batch=>{
      const margin=changes.margin??row.margin,factor=changes.factor??row.factor;
      const calculated=margin==null?null:livePricingValue({...row,cost:batch.cost,mrp:batch.mrp,selling:null},{margin,factor},'selling');
      return <div key={batch.inventoryId} className="my-2 rounded border p-2 min-w-64">
        <b>Batch {batch.batchId??'not recorded'} · Inventory #{batch.inventoryId}</b>
        <div>{batch.warehouse} · Expiry: {batch.expiry||'Not recorded'}</div>
        {batch.sku&&<div className="break-all">SKU: {batch.sku}</div>}
        <div>Available: {batch.stock} packs</div>
        <div>Purchase/unit: {money(batch.baseCost)} · Purchase + costs: {money(batch.cost)}</div>
        <div>MRP: {money(batch.mrp)} · Calculated price: {money(calculated)}</div>
        {batch.selected&&<div className="font-semibold text-blue-800">{row.scope?.startsWith('warehouse:')?'This inventory row':'Cost source for this entity price'}</div>}
      </div>;
    })}
  </details>;
}
